import { action, observable } from 'mobx'

import Ds from './ds'

class Addresses {
  @observable data = []
  @observable address = []
  @observable allAddresses = []
  @observable billingAddresses = []
  @observable shippingAddresses = []
  @observable addressTypes = []

  @observable ds = new Ds()

  @action loadAllAddressesByType(type, callback) {
    let query = `{ addresses(addressTypeId: ${ type } hash: "${ localStorage.getItem('userHash') }") { id companyId addressTypeId name address city state zipCode country } }`
    this.ds.query(query, (data) => {
      this.allAddresses = data.addresses

      if (callback != null) {
        callback()
      }
    })
  }

  @action newAddress(companyId, addressTypeId, name, address, city, state, zipCode, country, callback) {
    let query = `mutation {
      addAddress(
        companyId: ${ companyId },
        addressTypeId: ${ addressTypeId },
        name: "${ name }",
        address: "${ address }",
        city: "${ city }",
        state: "${ state }",
        zipCode: "${ zipCode }",
        country: "${ country }",
        hash: "${ localStorage.getItem('userHash') }"
      ) { id } }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadCompanyShippingAddresses(companyId)
      this.loadCompanyBillingAddresses(companyId)
      console.log('Callback: ', callback);
      if (callback) {
        return callback();
      }
    })
  }

  @action loadAllAddressTypes(callback) {
    this.ds.query(`{ addressTypes(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.addressTypes = data.addressTypes

      if (callback) {
        return callback(data.addressTypes)
      }
    })
  }

  @action loadAllAddresses(companyId, addressTypeId) {
    this.ds.query(`{ addresses(companyId: ${ companyId }, addressTypeId: ${ addressTypeId }, hash: "${ localStorage.getItem('userHash') }")  { id name address city state zipCode country } }`, (data) => {
      this.data = data.addresses
    })
  }

  @action loadCompanyAddressesByType(companyId, addressTypeId, callback) {
    this.ds.query(`{ addresses(companyId: ${ companyId }, addressTypeId: ${ addressTypeId }, hash: "${ localStorage.getItem('userHash') }")  { id name address city state zipCode country } }`, (data) => {
      callback(data)
    })
  }

  @action loadCompanyShippingAddresses(companyId, callback) {
    this.loadCompanyAddressesByType(companyId, 2, (data) => {
      this.shippingAddresses = data.addresses

      if (callback) {
        return callback()
      }
    })
  }

  @action loadCompanyBillingAddresses(companyId, callback) {
    this.loadCompanyAddressesByType(companyId, 1, (data) => {
      this.billingAddresses = data.addresses

      if (callback) {
        return callback()
      }
    })
  }

  @action loadAddress(addressId, callback) {
    let query = `{
      addresses(id: ${ addressId }, hash: "${ localStorage.getItem('userHash') }")  {
        id
        name
        address
        city
        state
        zipCode
        country
        addressTypeId
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (data.addresses.length > 0) {
        let address = data.addresses[0]

        this.address = address
        callback(address)
      } else {
        console.log('Nothing from query')
      }
    })
  }

  @action updateAddress(params, callback) {
    let query = `mutation { updateAddress(
      id: ${ params.id },
      companyId: ${ params.companyId },
      addressTypeId: ${ params.addressTypeId },
      address: "${ params.address }",
      name: "${ params.name }",
      city: "${ params.city }",
      state: "${ params.state }",
      zipCode: "${ params.zipCode }",
      country: "${ params.country }",
      hash: "${ localStorage.getItem('userHash') }"
    ) { id } }`
    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action deleteAddress(id, companyId, hash) {
    this.ds.query(`mutation {
      deleteAddress(
        id: ${ id },
        hash: "${ hash }"
      ) { id }
    }`, (data) => {
      this.loadCompanyShippingAddresses(companyId)
      this.loadCompanyBillingAddresses(companyId)
    })
  }
}

export default new Addresses()



// WEBPACK FOOTER //
// ./src/stores/addresses.js